import {
    getAction,
    deleteAction,
    putAction,
    postAction
} from '../http'

export default {

    getAccountInfo(params = {}) {
        return getAction('/api/design/sysUser/getAccountInfo', params);
    },

    //展示用户所属团队
    listTeamByUser(params = {}){
        return getAction('/api/design/sys_depart/listTeamByUser',params)
    },

    //展示用户所属企业
    listCompanyByUser(params = {}){
        return getAction('/api/design/sys_depart/listCompanyByUser',params)
    }

}